export interface ParseSuccess<T> {
  result: 'success'
  params: T
}

export interface ParseError {
  result: 'error'
  errors: Record<string, string[]>
}

export type ParseResult<T> = ParseSuccess<T> | ParseError

export type ParamsFunctionResolver = <T>(params: T) => ParseResult<T>

export const isSuccessResult = <T>(params: ParseResult<T>): params is ParseSuccess<T> => {
  return params.result === 'success'
}

export const isErrorResult = <T>(params: ParseResult<T>): params is ParseError => {
  return params.result === 'error'
}
